import React, { useEffect, useState } from "react";
import { FiHome, FiPackage, FiBell, FiUser, FiSearch } from "react-icons/fi";

export default function LogisticHomeScreen() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  // Simulate API call (replace with real backend)
  useEffect(() => {
    const fetchOrders = async () => {
      try {
        // Replace this with your real API
        const data = [
          { id: 1, group: "#123459", products: 4, status: "Available", amount: 3200 },
          { id: 2, group: "#123460", products: 2, status: "Available", amount: 1800 },
          { id: 3, group: "#123461", products: 6, status: "Busy", amount: 5000 },
          { id: 4, group: "#123462", products: 1, status: "Available", amount: 900 },
        ];

        // Simulate delay
        setTimeout(() => {
          setOrders(data);
          setLoading(false);
        }, 1000);
      } catch (error) {
        console.error("Error fetching orders:", error);
        setLoading(false);
      }
    };

    fetchOrders();
  }, []);

  return (
    <div className="min-h-screen bg-[#F1F3F2] flex flex-col max-w-md mx-auto relative">

      <div className="bg-white pt-5 pb-2 fixed top-0 left-0 right-0 mx-auto max-w-md mb-3">
        {/* Header */}
        <div className="px-5 py-4 flex justify-between items-center">
          <h1 className="text-2xl font-bold text-black">Home Page</h1>
          <FiSearch size={24} />
        </div>

        {/* Filter Tabs */}
        <div className="px-5 pb-4 flex gap-3">
          <button className="bg-white border border-gray-300 text-black text-sm font-medium px-4 py-2 rounded-md">
            All
          </button>
          <button className="bg-[#19C463] text-black text-sm font-medium px-4 py-2 rounded-md">
            Suggested
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 bg-[#F1F3F2] px-5 pb-24 overflow-y-auto mt-[170px]">

        {/* Loading State */}
        {loading && (
          <p className="text-center text-gray-500 mt-10">Loading orders...</p>
        )}

        {/* Empty State */}
        {!loading && orders.length === 0 && (
          <p className="text-center text-gray-500 mt-10">No orders available</p>
        )}

        {/* Orders List */}
        {!loading &&
          orders.map((order) => (
            <div
              key={order.id}
              className="bg-white rounded-lg p-4 mb-3 shadow-sm"
            >
              <h3 className="text-base font-bold text-black mb-1 text-left">
                Group <span>{order.group}</span>
              </h3>
              <p className="text-sm text-black mb-1 text-left">
                Product: <span>{order.products}</span>
              </p>

              <div className="flex justify-between items-center">
                <p className="text-sm text-black">
                  Status: <span>{order.status}</span>
                </p>
                <p className="text-lg font-bold text-black">
                  Amount: ₦ <span>{Number(order.amount || 0).toLocaleString("en-NG")}</span>
                </p>
              </div>
            </div>
          ))}
      </div>

      {/* Bottom Navigation */}
      <div className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md bg-white border-t border-gray-200 flex justify-around items-center py-2 pb-4 px-2">
        <div className="flex flex-col items-center gap-1">
          <FiHome size={24} color="#19C463" />
          <span className="text-xs text-[#19C463] font-bold">Home</span>
        </div>

        <div className="flex flex-col items-center gap-1">
          <FiPackage size={24} />
          <span className="text-xs text-black">Deliveries</span>
        </div>

        <div className="flex flex-col items-center gap-1">
          <FiBell size={24} />
          <span className="text-xs text-black">Notification</span>
        </div>

        <div className="flex flex-col items-center gap-1 relative">
          <FiUser size={24} />
          <span className="text-xs text-black">Profile</span>
        </div>
      </div>
    </div>
  );
}


